import React from 'react';
import Alert from '@material-ui/core/Alert';
import { Box, Button, Grid } from '@material-ui/core'
import { useNavigate } from 'react-router-dom';
import NextIcon from '@material-ui/icons/ArrowForward';
import { useTranslation } from 'react-i18next';

function AvailableDomain(props) {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const dominio = props.dominio;
    const tld = props.tld;
    const eventDomain = props.eventDomain;
    const epp = props.epp;
    const curcode = props.curcode;

    function handleRoute() {
        navigate('/cart/domain/revorder/', { state: { domainName: dominio, tld: tld, eventDomain: eventDomain, epp: epp, curcode: curcode } });
    }

    return (
        <Grid>
            <Box mt={3}>
                {eventDomain === 'domainregister' && <Alert severity="success"><strong>{dominio}:</strong> {t('availableForRegistration')}</Alert>}
                {eventDomain === 'domaintransfer'
                    && <Alert severity="success"><strong>{dominio}:</strong> {t('eligibleForTransfer')} <br></br> {t('transferNotice')}</Alert>}
            </Box>

            <Grid container dir="rtl">
                <Box mt={3}>
                    <Button color='success' variant='contained' startIcon={<NextIcon sx={{marginRight: '-8px', marginLeft: '6px'}} />}  onClick={handleRoute}>
                        {t('next')}
                    </Button>
                </Box>

            </Grid>

        </Grid>


    )
}

export default AvailableDomain;